import { styled, useTheme } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { useState, createElement, Fragment } from 'react';
import { getStyleProp } from '../utilities/get-styleprop.js';
import { b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Header as Header$2, Div } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import Spinner from '../Spinner/Spinner.js';
import { S as SpinnerSize } from '../utils-fabc7ae7.js';
import 'react-spring/renderprops.cjs';
import '../Badge/Badge.js';
import '../ClickOutside/ClickOutside.js';
import Tooltip from '../Tooltip/Tooltip.js';
import '../NavBar/NavBar.js';
import '../ScrollingMenu/defaultSettings.js';
import '../ScrollingMenu/utils/index.js';
import '../ScrollingMenu/InnerWrapper.js';
import ScrollingMenu from '../ScrollingMenu/ScrollingMenu.js';
import '../ScrollingMenu/ArrowWrapper.js';
import { HeaderTopNavBar } from './HeaderTopNavBar.js';
import HeaderNavItem from './HeaderNavItem.js';
import { HeaderBottomNavBar } from './HeaderBottomNavBar.js';

const Header = styled(Header$2)`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  z-index: ${({
  theme
}) => theme.zIndex.header};
`;
const BackgroundLoadingIndicator = styled(Div)`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  position: absolute;
  right: 0;
  width: 50px;
`;

function Header$1({
  topNavBar = null,
  bottomNavBar = null,
  hasSideMenu,
  isSideMenuOpen,
  topMenuItems,
  bottomMenuItems,
  showBackButton,
  logo = null,
  styles = {},
  toggleSideMenu,
  onBackButtonClick,
  onRenderTopMenu,
  closeSideMenu,
  withFeatchIndicator = null,
  isLoadingIndicatorVisible
}) {
  const theme = useTheme();
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const getOverrideStyleProp = key => {
    return getStyleProp(key, styles, theme);
  };
  const renderMenuItems = (items, isBottom = false) => {
    return items.map(item => {
      return /*#__PURE__*/createElement(HeaderNavItem, _extends({
        key: item.title,
        bottom: isBottom
      }, item), item.title, " ", item.metaRender && item.metaRender(item));
    });
  };
  const handleSelect = key => {
    setSelectedMenuItem(key);
  };
  const topMenu = /*#__PURE__*/createElement(HeaderTopNavBar, getOverrideStyleProp('topNav'), logo && logo, onRenderTopMenu && onRenderTopMenu(closeSideMenu), topMenuItems && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Div, {
    flexGrow: "1"
  }), renderMenuItems(topMenuItems)));
  const bottomMenu = bottomMenuItems || hasSideMenu ? /*#__PURE__*/createElement(HeaderBottomNavBar, getOverrideStyleProp('bottomNav'), hasSideMenu && /*#__PURE__*/createElement(HeaderNavItem, {
    title: "Menu",
    onClick: toggleSideMenu,
    iconProps: {
      glyph: isSideMenuOpen ? icons.CLOSE : icons.MENU
    },
    isToggle: true,
    isToggleActive: false,
    bottom: true,
    styles: {
      root: {
        float: 'left'
      }
    },
    props: {
      root: {
        testId: 'menu'
      }
    }
  }), showBackButton && /*#__PURE__*/createElement(HeaderNavItem, {
    onClick: onBackButtonClick,
    iconProps: {
      glyph: icons.CHEVRON_DOWN,
      rotate: 90
    },
    bottom: true,
    isToggle: true,
    props: {
      root: {
        testId: 'back'
      }
    }
  }), bottomMenuItems && /*#__PURE__*/createElement(ScrollingMenu, {
    data: renderMenuItems(bottomMenuItems, true),
    arrowLeft: /*#__PURE__*/createElement(ScrollingMenu.ShadowAsArrow, {
      left: true
    }),
    arrowRight: /*#__PURE__*/createElement(ScrollingMenu.ShadowAsArrow, null),
    hideArrows: true,
    hideSingleArrow: true,
    scrollToSelected: true,
    onSelect: handleSelect,
    selected: selectedMenuItem,
    clickWhenDrag: false,
    alignCenter: false
  }), withFeatchIndicator && /*#__PURE__*/createElement(BackgroundLoadingIndicator, null, /*#__PURE__*/createElement(Tooltip, {
    message: isLoadingIndicatorVisible ? withFeatchIndicator.infoWithFetch : withFeatchIndicator.infoWithoutFetch,
    placement: "left"
  }, /*#__PURE__*/createElement(Spinner, {
    stopAnimation: !isLoadingIndicatorVisible,
    size: SpinnerSize.xSmall,
    isInline: true,
    color: "#575756"
  })))) : null;
  return /*#__PURE__*/createElement(Header, getOverrideStyleProp('root'), topNavBar || topMenu, bottomNavBar || bottomMenu);
}

export default Header$1;
